export default {
      id: "oc-draggable-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-draggable",
      toString: function () {
        return this.url;
      }
    }